import { topicItems } from './mockData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 mb-4">
              <i className="ri-hashtag text-accent-600 text-sm"></i>
              <span className="text-accent-700 text-xs font-medium">话题热议</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              影迷们正在热烈讨论的影视话题，快来看看大家都在关注什么
            </p>
          </div>

          <div className="flex flex-wrap gap-3 justify-center">
            {topicItems.map((item) => {
              const bgClass =
                item.color === 'primary' ? 'bg-primary-50 hover:bg-primary-100 text-primary-700' :
                item.color === 'accent' ? 'bg-accent-50 hover:bg-accent-100 text-accent-700' :
                'bg-secondary-50 hover:bg-secondary-100 text-secondary-700';

              return (
                <div
                  key={item.id}
                  className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-colors ${bgClass}`}
                >
                  <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
                  <span className="text-xs opacity-60">{item.count}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}